// material-ui
import { Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //
const credits = window.__ENV && window.__ENV.credits;
// const title = window.__ENV && window.__ENV.projectTitle;
const AuthFooter = () => (
    <Stack direction="row" justifyContent="space-between">
        {/* <Typography variant="h6" >
            {title}
        </Typography> */}
        <Typography variant="h6">
            {new Date().getFullYear()} &copy; {credits}
        </Typography>
    </Stack>
);

export default AuthFooter;
